import { JSX } from "react"

import { useParams } from "react-router"
import GameView from "../../View/GameView"

export default function GamePage(): JSX.Element {
  const { seed } = useParams()

  if (seed === undefined) {
    return <></>
  }

  return <GameView seed={seed} />
}
